package io.jsonize.web.screens.editor

enum class EditorViewMode {
    Code,
    Tree,
    Compare,
    Generator
}
